import { Routes, Route, Navigate } from 'react-router-dom';
import TopContactBar from './components/TopContactBar';
import Header from './components/Header';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';
import ScrollToTop from './components/ScrollToTop';
import CalendlyModal from './components/CalendlyModal';
import BackToTop from './components/BackToTop';
import DisclaimerModal from './components/DisclaimerModal';
import PortalLayout from './components/PortalLayout';
import Home from './pages/Home';
import ServicesPage from './pages/Services';
import WhoWeServePage from './pages/WhoWeServe';
import ProcessPage from './pages/Process';
import InsightsPage from './pages/Insights';
import InsightArticlePage from './pages/InsightArticle';
import AboutPage from './pages/About';
import TeamPage from './pages/TeamPage';
import ContactPage from './pages/Contact';
import DisclosuresPage from './pages/Disclosures';
import NotFoundPage from './pages/NotFound';
import CommunityPage from './pages/Community';
import TaxPreparationPage from './pages/how-we-work/tax-preparation';
import EmployeeLoginPage from './pages/employee/Login';
import EmployeeDashboardPage from './pages/employee/Dashboard';
import EmployeeArticlesPage from './pages/employee/Articles';
import ArticleEditorPage from './pages/employee/ArticleEditorPage';
import { CalendlyProvider } from './hooks/useCalendly';

const isEmployeeHost = typeof window !== 'undefined' && window.location.hostname.startsWith('employee.');

function EmployeePortalApp() {
  return (
    <Routes>
      <Route path="/login" element={<EmployeeLoginPage />} />
      <Route element={<PortalLayout />}>
        <Route path="/dashboard" element={<EmployeeDashboardPage />} />
        <Route path="/articles" element={<EmployeeArticlesPage />} />
        <Route path="/articles/new" element={<ArticleEditorPage />} />
        <Route path="/articles/edit/:slug" element={<ArticleEditorPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function PublicSiteApp() {
  return (
    <CalendlyProvider>
      <DisclaimerModal />
      <div className="min-h-screen bg-white text-slate-700">
        <ScrollToTop />
        <TopContactBar />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/who-we-serve" element={<WhoWeServePage />} />
          <Route path="/process" element={<ProcessPage />} />
          <Route path="/how-we-work/tax-preparation" element={<TaxPreparationPage />} />
          <Route path="/insights" element={<InsightsPage />} />
          <Route path="/insights/:slug" element={<InsightArticlePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/community" element={<CommunityPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/disclosures" element={<DisclosuresPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
        <StickyCTA />
        <BackToTop />
        <CalendlyModal />
      </div>
    </CalendlyProvider>
  );
}

export default function App() {
  return isEmployeeHost ? <EmployeePortalApp /> : <PublicSiteApp />;
}
